/* eslint-disable no-undef */
import {
  CopyOutlined, DeleteOutlined, EditOutlined
} from '@ant-design/icons';
import {
  Modal, Popconfirm, Space, message
} from 'antd';
import { PropTypes } from 'prop-types';
import React, { useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../../components/button';
import Table from '../../../components/table';
import { getAllCropProfilesModulo } from '../../../redux/actions/crop-profile';
import {
  createModule, deleteModuleById, getModuleById, updateModuleById
} from '../../../redux/actions/module';
import { getAllSerialsEstablishment } from '../../../redux/actions/serial';
import { columnsModules } from '../../../utils/table-parser';
import FormModule from './form';

const initialValues = {
  numero: '',
  perfilcultivo: '',
  superficieTotal: '',
  superficieCultivo: '',
  volumenTotal: '',
  intraccionAire: '',
  extraccionAire: '',
  luminaria: '',
  circulacionAire: false,
  aireAcondicionado: false,
  generadorCO: false,
  frigorias: '',
  seriales: []
};

const Module = ({
  getData, id, establishment
}) => {
  const [showModalModuleNew, setShowModalModuleNew] = useState(false);
  const [showModalModuleEdit, setShowModalModuleEdit] = useState(false);
  const { cropprofiles } = useSelector((state) => state.cropprofileReducer);
  const { mod } = useSelector((state) => state.moduleReducer);
  const { serials } = useSelector((state) => state.serial);
  const rol = localStorage.getItem('rol');

  const dispatch = useDispatch();
  const openModalNew = () => {
    setShowModalModuleNew(true);
  };

  const closeModalNew = () => {
    setShowModalModuleNew(false);
  };

  const handleshowModalModuleNew = () => {
    dispatch(getAllCropProfilesModulo(id));
    dispatch(getAllSerialsEstablishment(id));
    console.log('Seriales antes de abrir modal:', serials);
    openModalNew();
  };

  const handleCreateModule = (values) => {
    console.log('values:', values);
    const modulo = {
      numero: values.numero,
      perfilcultivo: values.perfilcultivo,
      establecimiento: id,
      seriales: values.seriales.map(serial => ({
        serial: serial.serial,
        dispositivos: serial.dispositivos.map(device => ({
          dispositivo: device.dispositivo,
          posicion: device.posicion
        }))
      })),
      circulacionAire: values.circulacionAire || false,
      intraccionAire: values.intraccionAire || 0,
      extraccionAire: values.extraccionAire || 0,
      generadorCO: values.generadorCO || false,
      luminaria: values.luminaria || 0,
      superficieCultivo: values.superficieCultivo || 0,
      superficieTotal: values.superficieTotal || 0,
      volumenTotal: values.volumenTotal || 0,
    };

    console.log('modulo a crear:', modulo);
    dispatch(createModule(modulo, getData));
    closeModalNew();
  };

  const openModalEdit = () => {
    console.log('Se ejecuta');
    setShowModalModuleEdit(true);
  };

  const closeModalEdit = () => {
    setShowModalModuleEdit(false);
  };

  const handleModalEdit = async (data) => {
    await dispatch(getAllCropProfilesModulo(id));
    await dispatch(getAllSerialsEstablishment(id));
    await dispatch(getModuleById(data?.key));
    openModalEdit();
  };

  const handleDelete = (key) => {
    dispatch(deleteModuleById(key.key, getData));
  };

  const onEditModulo = ({ key, ...data }) => {
    const updatedData = {
      numero: data.numero,
      perfilcultivo: data.perfilcultivo,
      seriales: data.seriales.map(serial => ({
        serial: serial.serial,
        dispositivos: serial.dispositivos.map(device => ({
          dispositivo: device.dispositivo,
          posicion: device.posicion
        }))
      })),
      circulacionAire: data.circulacionAire || false,
      intraccionAire: data.intraccionAire || 0,
      extraccionAire: data.extraccionAire || 0,
      generadorCO: data.generadorCO || false,
      luminaria: data.luminaria || 0,
      superficieCultivo: data.superficieCultivo || 0,
      superficieTotal: data.superficieTotal || 0,
      volumenTotal: data.volumenTotal || 0,
      frigorias: data.frigorias || 0
    };

    console.log('modulo a actualizar:', updatedData);
    dispatch(updateModuleById(key, updatedData, getData));
    closeModalEdit();
  };
  const actionsColumn = (mod) => (
    <Space size="middle">
      <Button
        type="primary"
        icon={<EditOutlined />}
        color="transparent"
        text="Editar"
        onClick={() => handleModalEdit(mod)}
      />
      <Popconfirm
        placement="left"
        title="Desea eliminar el modulo?"
        onConfirm={() => handleDelete(mod)}
        okText="Si"
        cancelText="No"
      >
        <Button type="primary" icon={<DeleteOutlined />} text="Eliminar" color="transparent" />
      </Popconfirm>
    </Space>
  );

  const columsCopy = (text) => (
    <Space size="middle">
      {text.key}
      <CopyToClipboard
        text={text.key}
        onCopy={() => message.success('Copiado')}
      >
        <CopyOutlined />
      </CopyToClipboard>
    </Space>
  );
  return (
    <div className="container-page__box">
      <p className="container-page__subtitle">Módulos</p>
      <div className="container-page__button-new">
        {rol !== 'user' && (
          <Button
            text="Agregar módulo +"
            color="transparent"
            onClick={handleshowModalModuleNew}
          />
        )}
      </div>
      <div className="container-page__table">
        <Table
          columns={columnsModules}
          data={establishment.modulos}
          actionsColumn={actionsColumn}
          actions={rol !== 'user'}
          idCopyFunc={columsCopy}
          idCopy
        />
      </div>
      <Modal
        title="Crear nuevo modulo"
        open={showModalModuleNew}
        onOk={closeModalNew}
        onCancel={closeModalNew}
        destroyOnClose={true}
        footer={null}
      >
        <FormModule
          initialValues={initialValues}
          onSubmit={handleCreateModule}
          cropprofiles={cropprofiles}
          serials={serials?.data}
          establishment={establishment}
          type="add-module"
          key={showModalModuleNew ? 'open' : 'closed'}
        />
      </Modal>
      <Modal
        title="Editar modulo"
        open={showModalModuleEdit}
        onOk={closeModalEdit}
        onCancel={closeModalEdit}
        destroyOnClose={true}
        footer={null}
      >
        <FormModule
          initialValues={mod}
          onSubmit={onEditModulo}
          cropprofiles={cropprofiles}
          serials={serials?.data}
          establishment={establishment}
          type="edit"
          key={showModalModuleEdit ? 'open' : 'closed'}
        />
      </Modal>
    </div>
  );
};
Module.propTypes = {
  getData: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  establishment: (PropTypes.shape()).isRequired,
};
export default Module;
